module.exports = __webpack_public_path__ + "static/fipcmintorg4-3c5bb8a127c6a7addb7c1e1303b2ad4c.jpeg";